
export default class AdvancedOptions {
    jokers: number

    constructor () {
      this.jokers = 0
    }
}
